/**
 * Static map of newsletter prompt IDs to their full prompt texts.
 * Add the ID as a query parameter `newsletter_prompt_id` in email links.
 * Example URL: /project/llm/chat?newsletter_prompt_id=recent_news_tesla
 */

export const newsletter_prompts: Record<string, string> = {
  // finance prompts
  strongest_earnings_growth:
    'Which stocks in my portfolio have the strongest earnings growth?',
  undervalued_tech:
    'Show me undervalued tech companies with positive earnings momentum',
  key_financial_risks:
    'What are the key financial risks in my current holdings?',
  esg_risk: 'Which of my holdings have the highest ESG risk this week?',
  portfolio_top_movers:
    'Show me the top movers in my portfolio over the last 30 days',
  adidas_sentiment: 'what is driving the negative sentiment around Adidas?',
  bull_bear_esg_risk:
    'How do Adidas AG and Zalando SE compare on Bull & Bear and ESG Risk Scores?',

  // news prompts:
  news_events:
    'What global news events are currently increasing risk for companies in my portfolio?',
  sectors_sentiment:
    'Which sectors are seeing the most negative news sentiment this month? ',
  general_risk_companies:
    'Show me companies with a rising general risk score due to recent news coverage.',
  sentiment_drop:
    'Which companies in my portfolio have seen the biggest sentiment drop this week?',
  highest_general_risk:
    'What news events are driving the highest Generak Risk score in my holdings right now? ',
  portfolio_negative_sentiment:
    'Which of my holdings have had the most negative news coverage this week?',
  general_top_movers:
    'Show me the top general risk movers in my portfolio over the last 30 days.',
  tesla_sentiment:
    'What major news events have impacted Tesla sentiment in the last 30 days?',
  portfolio_high_risk:
    'Which companies in my portfolio have the highest general risk score right now?',

  // ESG prompts:

  stocks_esg:
    'Which stocks in my portfolio have the strongest ESG scores right now?',
  rising_esg_risk:
    'Show me companies with rising ESG Risk Scores due to environmental controversies.',
  governance_score_sector_holdings:
    'How does the Governance score compare across my financial sector holdings?',
  portfolio_esg_risk_score:
    'Which companies in my portfolio have the worst ESG Risk Score this month?',
  amazon_social_score:
    ' What is driving the Social score decline for Amazon over the last quarter?',
  portfolio_high_esg_risk:
    'Which of my holdings have the highest ESG risk this week?',
  esg_top_movers:
    'Show me the top ESG score movers in my portfolio over the last 30 days',
  adidas_governance_score:
    'What governance controversies are impacting Adidas right now?',
  tesla_comparaison:
    'How does Tesla ESG Risk Score compare to other manufacturers?',
  bp_e_score:
    ' Which news events are currently driving BP Environmental score down?',
  companies_g_score:
    'Show me companies with strong Governance score in the financial sector.',

  //risk prompts:

  stocks_risk:
    'Which stocks in my portfolio carry the highest overall risk right now? ',
  credit_risk_companies:
    'Show me companies with worsening credit risk signals that haven not been downgraded yet.',
  risk_overview:
    ' What are the key financial risks in my current holdings across ESG Risk and General Risk scores?',
  portfolio_general_risk_score:
    'Which companies in my portfolio have seen the biggest general risk score increase this month?',
  portfolio_credit_risk:
    'Are there any holdings in my portfolio showing early credit risk signals right now?',
  portfolio_combined_risk:
    'Which of my holdings have the highest combined risk exposure this week?',
  portfolio_credit_risk_30_days:
    'Show me companies in my portfolio with rising credit risk signals over the last 30 days.',
  adidas_risk_events:
    'What risk events are currently driving Adidas general risk score up?',
  tesla_risk_events:
    'What are the key regulatory risk events currently affecting Tesla?',
  banks_credit_risk:
    'Which European banks have the highest credit risk signals in the news right now?',
  shell_bp_comparaison:
    'Compare ESG risk and general risk scores for Shell and BP.',
  emerging_risk:
    'Is Microsoft still a safe hold for my portfolio, or are there emerging risks I am missing?',
  bull_bear_comparaison:
    'Compare Apple and Alphabet on Bull & Bear and ESG Risk Score',
  tesla_news: 'What adverse news has affected Tesla since January 2025?',
};
